import { Eye, EyeOff } from 'lucide-react';
import { type ComponentPropsWithoutRef, useState } from 'react';

// Native <input> wrapped with the designer's eye-toggle button. Spreads
// remaining props through so React Hook Form's `register('password')` works
// directly:
//
//   <PasswordInput id="password" {...register('password')} />
//
// Stays as a native input + `.sc-input` class per the locked pixel-perfection
// rule in auth-feature-plan.md (shadcn Input not used for auth forms).
type PasswordInputProps = Omit<ComponentPropsWithoutRef<'input'>, 'type'>;

export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const [revealed, setRevealed] = useState(false);

  return (
    <div className="relative">
      <input
        {...props}
        type={revealed ? 'text' : 'password'}
        className={`sc-input ${className ?? ''}`.trim()}
      />
      <button
        type="button"
        className="absolute top-1/2 end-4 -translate-y-1/2 w-4 h-4 text-placeholder"
        onClick={() => setRevealed((r) => !r)}
        aria-label={revealed ? 'Hide password' : 'Show password'}
        aria-pressed={revealed}
      >
        {revealed ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
      </button>
    </div>
  );
}
